import DownloadDocumentIcon from "./DownloadDocumentIcon";

export default DownloadDocumentIcon;
